import React, { memo } from 'react';
import { Price } from '@pegasus/translation';
import { useConfig } from '@browsing/config';
export var FormatPrice = function (_a) {
    var price = _a.price, _b = _a.superscript, superscript = _b === void 0 ? '' : _b, maximumFractionDigits = _a.maximumFractionDigits;
    var config = useConfig();
    var maximumFractionDigitsConfig = maximumFractionDigits !== null && maximumFractionDigits !== void 0 ? maximumFractionDigits : config.maximumFractionDigits;
    return (React.createElement(Price, { cents: price, superscript: superscript, overrideCurrencyFormat: config.overrideCurrencyFormat, maximumFractionDigits: maximumFractionDigitsConfig }));
};
FormatPrice.displayName = 'FormatPrice';
export default memo(FormatPrice);
